// removed by extract-text-webpack-plugin
module.exports = {"container":"infobulle__container__2eEVY","main":"infobulle__main__3R6eP","content":"infobulle__content__3dGvW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/infobulle/infobulle.scss
// module id = 228
// module chunks = 0